import { apiRequest } from '../client';

export interface TaskView {
  id: string;
  name: string;
  processInstanceId: string;
  processDefinitionKey: string;
  assignee: string | null;
  candidateGroups: string[];
  createTime: string;
  dueDate: string | null;
}

export interface WorkflowBindingView {
  id: string;
  processInstanceId: string;
  processDefinitionKey: string;
  documentType: string;
  documentId: string;
  status: 'ACTIVE' | 'COMPLETED' | 'CANCELLED';
}

export const workflowApi = {
  /** Inbox by assignee. Either assignee OR candidateGroup must be set. */
  tasksForAssignee: (assignee: string) =>
    apiRequest<TaskView[]>(`/api/workflow/tasks?assignee=${encodeURIComponent(assignee)}`),

  /** Inbox by candidate group. */
  tasksForGroup: (group: string) =>
    apiRequest<TaskView[]>(
      `/api/workflow/tasks?candidateGroup=${encodeURIComponent(group)}`
    ),

  getTask: (taskId: string) => apiRequest<TaskView>(`/api/workflow/tasks/${taskId}`),

  claim: (taskId: string, assignee: string) =>
    apiRequest<void>(`/api/workflow/tasks/${taskId}/claim`, {
      method: 'POST',
      body: { assignee }
    }),

  complete: (taskId: string, variables: Record<string, unknown> = {}) =>
    apiRequest<void>(`/api/workflow/tasks/${taskId}/complete`, {
      method: 'POST',
      body: { variables }
    }),

  bindingForDocument: (documentType: string, documentId: string) =>
    apiRequest<WorkflowBindingView>(
      `/api/workflow/bindings?documentType=${encodeURIComponent(documentType)}&documentId=${documentId}`
    )
};
